import React from 'react'
import { PropTypes } from 'prop-types'
import EdgeLogo from 'images/edge-logo.svg'
import { usePermittedAccess } from 'components/common/hooks/usePermittedAccess'
import { IntercomLauncher } from 'components/common/intercom-launcher'
import { SidebarItem } from './components/sidebar-item'
import classNames from 'classnames/bind'
import styles from './Sidebar.module.scss'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useAuth } from 'config/context/authContext'

const cx = classNames.bind(styles)

const Sidebar = ({ mainData }) => {
  const { showPolePriceAudit } = useFlags()

  const { polePriceAuditEnabled } = useAuth()

  const {
    me: { isSingleSite },
  } = mainData

  const {
    widgetPermissions: { viewAnalytics, viewPerformanceReportingPortfolio, viewPolePriceAudit },
  } = usePermittedAccess()

  // Only display Pole Price Audit sidebar item if LaunchDarkly flag, company permission and user permission are all true
  const displayPolePriceAudit = showPolePriceAudit && polePriceAuditEnabled && viewPolePriceAudit

  // Display Pole Price Audit sidebar tooltip if LaunchDarkly flag user permission are true, but company permission is false
  const displayPolePriceAuditTooltip = showPolePriceAudit && !polePriceAuditEnabled && viewPolePriceAudit

  return (
    <nav className={cx('side-bar')}>
      <div className={cx('edge-logo')}>
        <img src={EdgeLogo} alt="logo" width={35} height={35} />
      </div>
      {(!isSingleSite || viewAnalytics) && (
        <SidebarItem to="/stations" icon="stations" exact={false} />
      )}
      {!isSingleSite && (
        <SidebarItem
          to="/performance"
          icon="performance"
          exact
          disabled={!viewPerformanceReportingPortfolio}
        />
      )}
      {viewAnalytics ?
         (
          <SidebarItem
            to="/analytics"
            icon="analytics"
            exact
          />
        ) : <SidebarItem icon="analytics" tooltipTextTranslationKey="widgets.sidebar.comingSoon" />
      }
      {displayPolePriceAudit &&
        <SidebarItem
          to="/pole-price-audit"
          icon="polePriceAudit"
          exact
        />
      }
      {displayPolePriceAuditTooltip && <SidebarItem icon="polePriceAudit" tooltipTextTranslationKey="widgets.sidebar.polePriceAuditUpsell" />}
      <IntercomLauncher />
    </nav>
  )
}

Sidebar.propTypes = {
  mainData: PropTypes.shape().isRequired,
}

export { Sidebar }
